"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLegacyFontSize = exports.getLineHeight = void 0;
var _stencilReactThemeDefault = require("@amzn/stencil-react-theme-default");
const getLineHeight = _ref => {
  let {
    lineHeight,
    fontSize,
    breakpoint
  } = _ref;
  if (lineHeight) {
    return (0, _stencilReactThemeDefault.lineHeightPropAdapter)(lineHeight, breakpoint) || lineHeight;
  } else if (fontSize) {
    return (0, _stencilReactThemeDefault.lineHeightPropAdapter)(fontSize, breakpoint);
  } else {
    return undefined;
  }
};
exports.getLineHeight = getLineHeight;
const isLegacyFontSize = fontSize => {
  return fontSize && !!(0, _stencilReactThemeDefault.fontSizePropAdapter)(fontSize);
};
exports.isLegacyFontSize = isLegacyFontSize;